/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, Button, ListItemIcon, ListItemText, Menu, Stack, Typography } from "@mui/material";
import CustomerAvatar from "@/src/components/CustomerAvatar/CustomerAvatar";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { useId, useState } from "react";
import { AccountBoxOutlined, KeyboardArrowDown, KeyboardArrowUp, LogoutOutlined } from "@mui/icons-material";
import MenuItem from "@mui/material/MenuItem";
import { Link, useNavigate } from "react-router";
import { logout } from "@/src/store/login/actions";
import { headerActionsAuthenticatedStyle } from "@/src/components/HeaderActionsAuthenticated/headerActionsAuthenticatedStyle";

export default function HeaderActionsAuthenticated() {
  const id = useId();
  const menuId = `${id}-menu`;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { customer, refreshCustomer } = useCustomer();
  const navigate = useNavigate();

  const open = !!anchorEl;

  const handleLogout = () => {
    logout();
    refreshCustomer();
    navigate("/");
  };

  return (
    <>
      <Button
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
        variant={"text"}
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open}
        sx={{ padding: "0.5rem" }}
      >
        <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={0.5}>
          <CustomerAvatar />
          <Box sx={{ paddingLeft: "0.5rem" }}>{customer?.person.fullName}</Box>
          {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </Stack>
      </Button>
      <Menu
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        id={menuId}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem component={Link} to="/servicewelt/mein-konto" onClick={() => setAnchorEl(null)} sx={headerActionsAuthenticatedStyle.listItem}>
          <ListItemIcon>
            <AccountBoxOutlined color={"primary"} />
          </ListItemIcon>
          <ListItemText>Mein Konto</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleLogout} sx={headerActionsAuthenticatedStyle.listItem}>
          <ListItemIcon>
            <LogoutOutlined color={"primary"} />
          </ListItemIcon>
          <ListItemText>Abmelden</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
